{
  "account.profile.title": "Your Profile",
  "account.profile.signedInAs": "Signed in as {email}",
  "account.profile.signedInAsNamed": "Signed in as {name} ({email})",
  "account.profile.logout": "Log out",
  "account.profile.settings.heading": "Settings",
  "account.signIn.failed": "Sign-in failed. Please try again.",
  "account.signIn.play": "Play",
  "account.signIn.logoAlt": "Suikamon",
  "account.signIn.welcomeTitle": "Welcome to Suikamon",
  "account.signIn.title": "Sign in to Suikamon",
  "account.signIn.welcomeSubtitle": "Start playing free in seconds — or sign in to keep your progress.",
  "account.signIn.subtitle": "Pick how you'd like to sign in and start playing.",
  "account.signIn.continueGuestPet": "Continue with your free pet",
  "account.signIn.playAsGuest": "Play as Guest",
  "account.signIn.orSignIn": "or sign in",
  "account.signIn.withEmail": "Continue with Email",
  "account.signIn.emailPlaceholder": "you@example.com",
  "account.signIn.emailAria": "Email address",
  "account.signIn.sending": "Sending…",
  "account.signIn.emailMeCode": "Email me a code",
  "account.signIn.codeSent": "We sent a code to <b>{email}</b>. Enter it, or tap the link in the email.",
  "account.signIn.codeAria": "Sign-in code",
  "account.signIn.signingIn": "Signing in…",
  "account.signIn.signIn": "Sign in",
  "account.signIn.differentEmail": "Use a different email",
  "account.signIn.withGoogle": "Continue with Google",
  "account.signIn.withProvider": "Continue with {provider}",
  "account.guest.signedUpKeepEvolving": "Signed up! Keep evolving your Suikamon. ✨",
  "account.guest.fallbackPetName": "your Suikamon",
  "account.guest.starterIneligible": "You already have a Suikamon — the free starter is for new trainers.",
  "account.profile.saveFailed": "Failed to save profile. Please try again.",
  "account.profile.unlinkTelegramFailed": "Failed to unlink Telegram. Please try again.",
  "account.profile.editTitle": "Edit Profile",
  "account.profile.chooseAvatarTitle": "Choose Avatar",
  "account.profile.cropAvatarTitle": "Crop Avatar",
  "account.profile.close": "Close",
  "account.profile.changeAvatar": "Change Avatar",
  "account.profile.setAvatar": "Set Avatar",
  "account.profile.removeAvatar": "Remove",
  "account.profile.displayName": "Display Name",
  "account.profile.displayNamePlaceholder": "Trainer",
  "account.profile.charCount": "{length}/{max}",
  "account.profile.xLabel": "X / Twitter",
  "account.profile.xPlaceholder": "yourhandle",
  "account.profile.telegramLabel": "Telegram",
  "account.profile.telegramLinked": "Linked",
  "account.profile.telegramLinkedAs": "Linked as @{username}",
  "account.profile.unlinking": "Unlinking…",
  "account.profile.unlink": "Unlink",
  "account.profile.saving": "Saving…",
  "account.profile.save": "Save",
  "account.profile.campaignSection": "Campaign",
  "account.profile.campaignHint": "Use a campaign trainer portrait as your profile picture",
  "account.profile.suikamonSection": "Your Suikamon",
  "account.profile.suikamonHint": "Pick a Suikamon you've discovered to use as your profile picture",
  "account.profile.back": "Back",
  "account.profile.evoStage": "Evo {stage}",
  "account.profile.zoom": "Zoom",
  "account.profile.useAvatar": "Use This Avatar",
  "account.welcome.featureBattle": "Battle",
  "account.welcome.featureEvolve": "Evolve",
  "account.welcome.featureCampaign": "Campaign",
  "account.welcome.defaultName": "Trainer",
  "account.welcome.eyebrow": "New trainer",
  "account.welcome.title": "Welcome, {trainerName}!",
  "account.welcome.subtitle": "Your Suikamon adventure starts here. Raise, battle, and evolve your very own pocket monster.",
  "account.welcome.start": "Let's go",
  "account.welcome.howTitle": "How it works",
  "account.welcome.howText": "Battle other trainers, evolve your Suikamon, and conquer the campaign.",
  "account.welcome.getTitle": "Get your first Suikamon",
  "account.welcome.getText": "Pick a free starter. Every other Suikamon is found in eggs as you level up.",
  "account.welcome.starterTitle": "Choose your starter",
  "account.welcome.starterSub": "Free — pick a Common and hatch it",
  "account.welcome.labTitle": "Try a battle first",
  "account.welcome.labSub": "Practice in the PvP Lab",
  "account.trainer.title": "Trainer Profile",
  "account.trainer.invalidAddress": "Invalid address",
  "account.trainer.back": "Back to Trainers",
  "account.trainer.loading": "Loading trainer profile...",
  "account.trainer.loadingDetail": "Fetching the trainer's collection.",
  "account.trainer.loadFailed": "Failed to load trainer profile.",
  "account.trainer.tryLater": "Please try again later.",
  "account.trainer.mainCompanion": "Main Companion",
  "account.trainer.view": "View",
  "account.trainer.pets": "Suikamons",
  "account.trainer.petCount": "{count, plural, one {# pet} other {# pets}}",
  "account.trainer.soulsHintOwn": "Your Last Souls collection — win each soul's trial in the Campaign to complete it.",
  "account.trainer.soulsHintOther": "The Last Souls this Keeper has saved on the campaign trail — one waits for every Suikamon species.",
  "account.freeCap.campaignShout": "Book One\nThe End",
  "account.freeCap.campaignLine": "What a story! Is there more?",
  "account.freeCap.campaignBody": "Sign up free to keep {petName} and every page you won.",
  "account.freeCap.levelShout": "Free play's\ntop level!",
  "account.freeCap.levelLine": "I can get even stronger!",
  "account.freeCap.levelBody": "Sign up free and {petName} keeps growing. Nothing you earned is lost.",
  "account.freeCap.portalCampaign": "That is all of free play's story. {petName} can replay any battle you won.",
  "account.freeCap.portalLevel": "{petName} is at free play's top level. Keep battling: the XP still counts.",
  "account.freeCap.fallbackPet": "Your Suikamon",
  "account.freeCap.keepPlaying": "Keep playing",
  "account.freeCap.signUp": "Sign up free",
  "account.freeCap.notNow": "Not now",
  "account.telegram.connectFailed": "Could not start the connection",
  "account.telegram.disconnectFailed": "Could not disconnect",
  "account.telegram.switchFailed": "Could not switch",
  "account.telegram.connected": "Connected",
  "account.telegram.on": "Telegram companion on",
  "account.telegram.followThis": "Follow this Suikamon on Telegram",
  "account.telegram.alertsHint": "{handle} · choose messages with /alerts",
  "account.telegram.disconnecting": "Disconnecting…",
  "account.telegram.disconnect": "Disconnect",
  "account.telegram.switching": "Switching…",
  "account.telegram.follow": "Follow",
  "account.telegram.oneMoreTap": "One more tap",
  "account.telegram.opensConnected": "Telegram opens and you're connected",
  "account.telegram.open": "Open Telegram",
  "account.telegram.fallback": "No Telegram here? Send <code>{command}</code> to the bot",
  "account.telegram.copyLabel": "Copy the link command",
  "account.telegram.copied": "Copied",
  "account.telegram.copy": "Copy",
  "account.telegram.title": "Telegram companion",
  "account.telegram.pitch": "A message when your Suikamon needs you — never more than one a day",
  "account.telegram.connecting": "Connecting…",
  "account.telegram.connect": "Connect",
  "account.signInNotice.finishing": "Finishing sign-in…",
  "account.signInNotice.retry": "Try again",
  "account.signInNotice.again": "Sign in again",
  "account.signInNotice.dismiss": "Dismiss",
  "account.signInError.expired": "That sign-in link has expired. Request a new one.",
  "account.signInError.unfinished": "Sign-in didn't finish. Please try again, or continue with email.",
  "account.signInError.failed": "Sign-in failed. Please try again.",
  "account.guestBanner.text": "You're playing as a guest — sign up free to save your Suikamon and keep your progress.",
  "account.guestBanner.textNamed": "You're playing as a guest — sign up free to save {name} and keep your progress.",
  "account.guestBanner.cta": "Sign up to save",
  "account.gate.portal": "Hatch your own Suikamon and start playing. It takes a few seconds.",
  "account.gate.title": "Start your journey",
  "account.gate.message": "Sign in to keep your Suikamon forever, or jump in and play free as a guest — no signup needed.",
  "account.gate.playFree": "Start playing free",
  "account.gate.signIn": "Sign in",
  "account.petName.required": "Pet name is required",
  "account.petName.tooShort": "Pet name must be at least {min} characters",
  "account.petName.tooLong": "Pet name must be less than {max} characters",
  "account.petName.invalidChars": "Pet name can only contain letters, numbers, spaces, hyphens, apostrophes, and basic punctuation (!.,?)",
  "account.petName.invalid": "Invalid pet name"
}
